var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Facebook_logo","fill":"#4460A0","fillRule":"nonzero"},React.createElement("path",{"d":"M9.614383,18 L0.993462,18 C0.444627,18 0,17.555097 0,17.006476 L0,0.993454 C0,0.444694 0.444697,0 0.993462,0 L17.006608,0 C17.555233,0 18,0.444694 18,0.993454 L18,17.006476 C18,17.555167 17.555163,18 17.006608,18 L12.419739,18 L12.419739,11.029408 L14.759445,11.029408 L15.109783,8.312845 L12.419739,8.312845 L12.419739,6.578491 C12.419739,5.791983 12.638142,5.256004 13.765984,5.256004 L15.204492,5.255375 L15.204492,2.825659 C14.955707,2.792553 14.101794,2.718589 13.108332,2.718589 C11.034313,2.718589 9.614383,3.984572 9.614383,6.309453 L9.614383,8.312845 L7.268671,8.312845 L7.268671,11.029408 L9.614383,11.029408 L9.614383,18 Z","id":"Facebook"})))]);
}

Facebook.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/facebook.svg
// module id = 1485
// module chunks = 0